import { CartLinesUpdateEvent } from '@shopify/events';
const rcRoot = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
const rcSectionIds = () => Array.from(new Set(Array.from(document.querySelectorAll('cart-items-component[data-section-id]')).map((el) => el.dataset.sectionId)));
if (!window.__rcCartSet) {
  window.__rcCartSet = true;
  document.addEventListener('click', async (event) => {
    const btn = event.target instanceof Element ? event.target.closest('[data-rc-set-qty],[data-rc-set-remove]') : null;
    if (!btn) return;
    const ctrl = btn.closest('[data-rc-set-ctrl]');
    if (!ctrl || ctrl.classList.contains('is-busy')) return;
    event.preventDefault();
    const keys = (ctrl.dataset.keys || '').split(',').filter(Boolean);
    if (!keys.length) return;
    const current = parseInt(ctrl.dataset.qty || '1', 10) || 1;
    const qty = btn.hasAttribute('data-rc-set-remove') ? 0 : Math.max(0, current + parseInt(btn.dataset.rcSetQty || '0', 10));
    const updates = {};
    keys.forEach((k) => { updates[k] = qty; });
    const sectionIds = rcSectionIds();
    const deferred = CartLinesUpdateEvent.createPromise();
    ctrl.classList.add('is-busy');
    ctrl.dispatchEvent(new CartLinesUpdateEvent({ action: qty === 0 ? 'remove' : 'update', context: 'cart', lines: keys.map((id) => ({ id, quantity: qty })), promise: deferred.promise }));
    try {
      const response = await fetch(rcRoot() + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ updates, sections: sectionIds.join(','), sections_url: window.location.pathname }) });
      const cart = await response.json();
      if (!response.ok) throw new Error(cart.description || cart.message || 'Cart update failed');
      deferred.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: { sections: cart.sections || undefined, items: cart.items, itemCount: cart.item_count, source: 'rc-set', didError: false } });
    } catch (error) {
      ctrl.classList.remove('is-busy');
      deferred.reject(error);
    }
  });
}
if (!window.__rcAccAdd) {
  window.__rcAccAdd = true;
  document.addEventListener('change', (event) => {
    const sel = event.target instanceof Element ? event.target.closest('[data-rc-acc-opt]') : null;
    if (!sel) return;
    const card = sel.closest('[data-rc-acc-card]');
    if (!card) return;
    const o = sel.selectedOptions && sel.selectedOptions[0];
    const b = card.querySelector('[data-rc-acc-add]');
    if (b) b.dataset.var = sel.value;
    if (o && o.dataset.img) { const im = card.querySelector('[data-rc-acc-img]'); if (im) im.src = o.dataset.img; }
    if (o && o.dataset.price) { const p = card.querySelector('[data-rc-acc-price]'); if (p) p.textContent = o.dataset.price; }
  });
  document.addEventListener('click', async (event) => {
    const btn = event.target instanceof Element ? event.target.closest('[data-rc-acc-add]') : null;
    if (!btn || btn.disabled) return;
    event.preventDefault();
    const vid = Number(btn.dataset.var);
    if (!vid) return;
    const sectionIds = rcSectionIds();
    const label = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding\u2026';
    const deferred = CartLinesUpdateEvent.createPromise();
    btn.dispatchEvent(new CartLinesUpdateEvent({ action: 'add', context: 'cart', lines: [{ merchandiseId: 'gid://shopify/ProductVariant/' + vid, quantity: 1 }], promise: deferred.promise }));
    try {
      const res = await fetch(rcRoot() + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: vid, quantity: 1 }], sections: sectionIds.join(','), sections_url: window.location.pathname }) });
      const j = await res.json();
      if (!res.ok) throw new Error(j.description || j.message || 'Could not add to bag');
      const cart = await (await fetch(rcRoot() + 'cart.js', { cache: 'no-store' })).json();
      deferred.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: { sections: j.sections || undefined, items: cart.items, itemCount: cart.item_count, source: 'rc-acc', didError: false } });
    } catch (error) {
      btn.disabled = false;
      btn.textContent = label;
      deferred.reject(error);
    }
  });
}
if (!window.__rcPop) {
  window.__rcPop = true;
  let pop = null;
  const css = "dialog.rc-pop{position:fixed;inset:0;width:100vw;height:100vh;max-width:none;max-height:none;margin:0;padding:3vh 2vw;border:0;background:transparent;overflow:hidden;box-sizing:border-box}" +
    "dialog.rc-pop[open]{display:flex;align-items:center;justify-content:center}" +
    "dialog.rc-pop::backdrop{background:rgba(10,10,10,.55)}" +
    ".rc-pop__box{position:relative;width:min(980px,96vw);height:min(92vh,960px);background:#fff;color:#111;border-radius:18px;overflow:hidden;box-shadow:0 30px 80px rgba(0,0,0,.35);animation:rcPopIn .2s ease}" +
    ".rc-pop__body{height:100%;overflow-y:auto;-webkit-overflow-scrolling:touch;overscroll-behavior:contain}" +
    ".rc-pop__body .rc-finder.rc-sec{padding-top:28px;padding-bottom:40px}" +
    ".rc-pop__x{position:absolute;top:12px;right:12px;z-index:5;width:40px;height:40px;border-radius:50%;border:0;background:#fff;color:#111;font-size:24px;line-height:1;cursor:pointer;box-shadow:0 2px 10px rgba(0,0,0,.18)}" +
    ".rc-pop__load{display:grid;place-items:center;height:100%;font:600 15px/1.4 -apple-system,BlinkMacSystemFont,'Helvetica Neue',Arial,sans-serif;color:#777}" +
    "@keyframes rcPopIn{from{opacity:0;transform:translateY(12px)}to{opacity:1;transform:none}}" +
    "@media(max-width:749px){dialog.rc-pop{padding:0}.rc-pop__box{width:100vw;height:100dvh;border-radius:0}}";
  const ensureCss = () => {
    if (document.getElementById('rc-pop-css')) return;
    const s = document.createElement('style');
    s.id = 'rc-pop-css';
    s.textContent = css;
    document.head.appendChild(s);
  };
  const loadScript = (src) => new Promise((resolve, reject) => {
    const s = document.createElement('script');
    s.src = src;
    s.onload = () => resolve();
    s.onerror = () => reject(new Error('script'));
    document.head.appendChild(s);
  });
  const close = () => {
    if (!pop) return;
    const p = pop;
    pop = null;
    try { if (p.open) p.close(); } catch (e) {}
    p.remove();
  };
  async function refreshCart() {
    try {
      const ids = rcSectionIds();
      const cart = await (await fetch(rcRoot() + 'cart.js', { cache: 'no-store' })).json();
      const target = document.querySelector('cart-items-component') || document.body;
      const d = CartLinesUpdateEvent.createPromise();
      target.dispatchEvent(new CartLinesUpdateEvent({ action: 'update', context: 'cart', lines: cart.items.map((i) => ({ id: i.key, quantity: i.quantity })), promise: d.promise }));
      let sections;
      if (ids.length) sections = await (await fetch(rcRoot() + '?sections=' + encodeURIComponent(ids.join(',')), { headers: { Accept: 'application/json' } })).json();
      d.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: { sections: sections || undefined, items: cart.items, itemCount: cart.item_count, source: 'rc-pop', didError: false } });
    } catch (e) {
      window.location.reload();
    }
  }
  async function open(a) {
    ensureCss();
    close();
    const href = a.getAttribute('href') || '/pages/find-your-case';
    const u = new URL(href, window.location.origin);
    u.searchParams.set('view', 'popup');
    const dlg = document.createElement('dialog');
    dlg.className = 'rc-pop';
    dlg.setAttribute('aria-label', 'Add more cases');
    dlg.innerHTML = "<div class='rc-pop__box'><button type='button' class='rc-pop__x' aria-label='Close'>&times;</button><div class='rc-pop__body'><div class='rc-pop__load'>Loading\u2026</div></div></div>";
    const host = a.closest('dialog[open]') || document.querySelector('dialog[open]') || document.body;
    host.appendChild(dlg);
    pop = dlg;
    try { dlg.showModal(); } catch (e) { dlg.setAttribute('open', ''); dlg.style.zIndex = '2147483000'; }
    dlg.querySelector('.rc-pop__x').addEventListener('click', (e) => { e.preventDefault(); e.stopPropagation(); close(); });
    dlg.addEventListener('click', (e) => { e.stopPropagation(); if (e.target === dlg) close(); });
    dlg.addEventListener('keydown', (e) => { e.stopPropagation(); });
    dlg.addEventListener('cancel', (e) => { e.preventDefault(); e.stopPropagation(); close(); });
    const body = dlg.querySelector('.rc-pop__body');
    try {
      const html = await (await fetch(u.toString(), { credentials: 'same-origin' })).text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fin = doc.querySelector('[data-rc-finder]');
      if (!fin) throw new Error('no finder');
      doc.querySelectorAll('link[rel="stylesheet"]').forEach((l) => {
        const h = l.getAttribute('href') || '';
        if (/\/rc[.-][^/]*\.css/.test(h) && !document.querySelector('link[href="' + h + '"]')) {
          const n = document.createElement('link');
          n.rel = 'stylesheet';
          n.href = h;
          document.head.appendChild(n);
        }
      });
      if (dlg !== pop) return;
      body.innerHTML = '';
      body.appendChild(document.importNode(fin, true));
      const srcs = Array.from(doc.querySelectorAll('script[src]')).map((s) => s.getAttribute('src'));
      const rcSrc = srcs.find((s) => /\/rc\.js/.test(s));
      const patchSrc = srcs.find((s) => /rc-finder-patch\.js/.test(s));
      if (!window.RC && rcSrc) await loadScript(rcSrc);
      if (window.RC && typeof window.RC.init === 'function') window.RC.init(body);
      if (!window.__rcPatchLoaded && patchSrc) await loadScript(patchSrc);
      const el = body.querySelector('[data-rc-finder]');
      const inst = el && el.__rc;
      if (inst && typeof inst.render === 'function') {
        inst.cartCases = parseInt(a.dataset.cases || '0', 10) || 0;
        const model = a.dataset.model;
        if (model && inst.models) {
          const m = inst.models.find((x) => window.RC.slug(x.label) === model);
          if (m) inst.s.model = m.k;
        }
        inst.render();
      }
    } catch (e) {
      window.location.href = href;
    }
  }
  document.addEventListener('click', (e) => {
    const a = e.target instanceof Element ? e.target.closest('[data-rc-finder-pop]') : null;
    if (!a) return;
    e.preventDefault();
    e.stopPropagation();
    open(a);
  }, true);
  window.addEventListener('rc:finder-added', () => {
    if (!pop) return;
    close();
    refreshCart();
  });
}
